import React, { useEffect, useState, useCallback } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { PanelUserDetailStyle } from '../../../centraldevida/UserDetails/PanelUserDetailStyle';
import { Box, Grid, Paper, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, Typography, makeStyles, useTheme } from '@material-ui/core';
import MigaPan from '../../../app/orussystem/component/MigaPan';
import { useDispatch } from 'react-redux';
import { DATE_END, DATE_INIT } from '../../../app/api-client/constants';
import { getResultsOfUsers } from '../../domain/EncuestasApi';
const useStyles = makeStyles((theme) => ({
  TableCell: {
    padding: theme.spacing(1),
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: 200, // Ajusta este valor según tu diseño
  },
  questionCell: {
    width: '12%', // Ajusta el ancho de las celdas de las preguntas
  },
  answerCell: {
    width: '5%', // Ajusta el ancho de las celdas de las respuestas
    whiteSpace: 'normal',
    wordWrap: 'break-word',
  },
  tableContainer: {
    overflowX: 'auto', // Habilita el scroll horizontal
    maxWidth: '100%', // Establece un ancho máximo para el contenedor
  },
}));

export const ResultadosPorUsuario = (props) => {
  const clases = useStyles();
  const classes = PanelUserDetailStyle();
  let init_date = localStorage.getItem(DATE_INIT);
  let end_date = localStorage.getItem(DATE_END)
  const [resultados, setResultados] = useState([]);
  const [telefonos, setTelefonos] = useState([]);
  const [titulo, setTitulo] = useState([]);
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [totalElements, setTotalElements] = useState(0)
  const [dateInit] = useState(init_date)
  const [dateEnd] = useState(end_date)

  const dispatch = useDispatch();
  const location = useLocation();

  let { id } = useParams();
  let idPoll = id === ":id" || id === "" ? 0 : id;
  const encuesta = location.state?.Encuesta || 'Sin encuesta';

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
    reload("", newPage, rowsPerPage)

  };
  //cambio de tamaño
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    reload("", 0, event.target.value)
    setPage(0)

  };
  const reload = (id, page, rowsperpage) => {
    getDataTable(id, page, rowsperpage)

  };


  const getDataTable = useCallback(async (id, page, rowsperpage) => {

    const pageResults = await getResultsOfUsers(dispatch, id, page, rowsperpage);

    try {

      const resultadosUsuarios = pageResults.content.map(user => user.respuestasUsuario);
      setResultados(resultadosUsuarios)
      const telefonos = pageResults.content.map(user => user.phone);
      const preguntasUnicas = resultadosUsuarios.flatMap(user => user.map(respuesta => respuesta.question));
      const preguntasUnicasSinDuplicados = Array.from(new Set(preguntasUnicas));
      setTelefonos(telefonos)
      setTotalElements(pageResults.totalElements);
      setTitulo(preguntasUnicasSinDuplicados)
    } catch (err) {
      console.log("Ocurrio un error", err)
    }
  }, [dispatch])


  useEffect(() => {
    const fetchData = async () => {
      // Ajustar la fecha de inicio y fin al cargar el componente
      const adjustedDateEnd = new Date(dateEnd);
      adjustedDateEnd.setDate(adjustedDateEnd.getDate() - 1);

      getDataTable(idPoll, page, rowsPerPage);
    }
    fetchData();
  }, [dateInit, dateEnd, getDataTable, idPoll, page, rowsPerPage]);



  const theme = useTheme(); // Obtén el tema

  const primaryColor = theme.palette.primary.main;

  return (
    <>
      <Grid item xs={12} >
        <br></br>
        <br></br>
        <MigaPan
          namePage={`Resultados usuarios ${encuesta}`}
          to="/"
          namePage2="Estaciones"
          to2="/basculas/"
          namePage3={`Resultados ${encuesta}`}
          to3={{
            pathname: `/polls/results/${idPoll}`,
            state: { Encuesta: encuesta },
          }}

        >
          Home
        </MigaPan>
      </Grid>
      <Paper className={classes.paper1} >
        <Grid>
          <Box
            component="span"
            m={1}
            className={`${classes.spreadBox} ${classes.box}`}
          >
            <Grid container alignItems="center" justifyContent='center' >
              <Grid item>
                <Grid item xs={12} sm container >
                  <Grid item xs container direction="column"  >
                    <Grid item xs>
                      <Typography align="center" justify="center" style={{ fontWeight: 'bold', fontSize: "45px" }} color='primary' >
                        Resultados
                      </Typography>
                      <Grid item xs={12} sm container alignItems="center" justifyContent="center" >
                        <Typography component="p" align="center">
                          {dateInit}
                        </Typography>
                        <Typography component="p" align="right" style={{ marginLeft: '10px' }}>
                          {dateEnd}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
          <div className={clases.tableContainer}> {/* Contenedor con scroll horizontal */}
            <Table>
              <TableHead color='primary'>
                <TableRow color='primary'>
                  <TableCell className={classes.TableCell} style={{ color: primaryColor, width: '5px' }}>telefono</TableCell>
                  {titulo.map((pregunta, index) => (
                    <TableCell key={index} className={classes.TableCell} style={{ paddingLeft: '0%', width: '6%', color: primaryColor }}>{pregunta}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {resultados.map((respuestasUsuario, index) => (
                  <TableRow key={index}>
                    <TableCell style={{ paddingLeft: '0%', width: '2%' }}>{telefonos[index]}</TableCell>
                    {respuestasUsuario.map((respuesta, indexRespuesta) => (
                      <TableCell key={indexRespuesta} style={{ paddingLeft: '0%', width: '6%' }}>{respuesta.answer}</TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
          <TablePagination
            component="div"
            count={totalElements}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelRowsPerPage="Datos por página:"
            style={{ color: primaryColor }}
            rowsPerPageOptions={[10, 25, 50, 100, 150, 200]}
          />
        </Grid>
      </Paper>
    </>
  );
}